import { attr, belongsTo } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const Field = ApplicationRecord.extend({
  static: {
    jsonapiType: 'fields',
  },
  attrs: {
    x: attr(),
    y: attr(),
    height: attr(),
    width: attr(),
    align: attr(),
    textSize: attr(),
    spacing: attr(),
    templateId: attr(),
    columnId: attr(),
    fontId: attr(),
    backgroundId: attr(),
    columnName: attr(),
    wrap: attr(),
    sampleText: attr(),
    color: attr(),
    text: attr(),
    png: attr(),
    template: belongsTo(),
    background: belongsTo(),
    font: belongsTo(),
    column: belongsTo(),
    personalizationBox: attr(),
    personalizationBoxUrl: attr(),
    overlayImageUrl: attr(),
    customized: attr(),
    customerEditable: attr(),
    fieldLabel: attr(),
    fieldPlaceholder: attr(),
    fieldRequired: attr(),
    autoFit: attr(),
    minFontSize: attr(),
    fontStyle: attr(),
    textDecoration: attr(),
    templatePageId: attr(),
    verticalAlign: attr(),
    horizontal: attr(),
    daysOffset: attr(),
    strokeColor: attr(),
    strokeWidth: attr(),
    rotation: attr(),
  },
})

export default Field
